import React, { Component } from 'react'
import styles from './flexRowCon.scss'

class FlexRowCon extends Component {
  render() {
    return (
      <div className={`${styles['c-flex-row-con']} ${this.props.className}`}>
        {this.props.children}
      </div>
    )
  }
}

export default FlexRowCon
